const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: u('photo-1600585154340-be6161a56a0c', 2000),
  lawn: '/images/lawn-after.jpg',
  lawnBefore: '/images/lawn-before.jpg',
  landscaping: u('photo-1466692476868-aef1dfb1e735', 1200),
  gutter: '/images/gutter-after.jpg',
  gutterBefore: '/images/gutter-before.jpg',
  window: '/images/windows-after.jpg',
  windowBefore: '/images/windows-before.jpg',
  bins: '/images/bins-after.jpg',
  binsBefore: '/images/bins-before.jpg',
  seasonal: '/images/hedges-trimmed.jpg',
  seasonalWinter: '/images/hedges-winter.jpg',
  yardOpening: '/images/yard-opening.jpg',
  yardClosing: '/images/yard-closing.jpg',
  featuredLawn: u('photo-1568605114967-8130f3a36994', 1600),
  recurring: u('photo-1570129477492-45c003edd2be', 1400),
  brand: u('photo-1600596542815-ffad4c1539a9', 2000),
  aboutHero: u('photo-1613490493576-7fde63acd811', 1800),
  contactSide: u('photo-1512917774080-9991f1c4c750', 1200),
  servicesHero: u('photo-1564013799919-ab600027ffc6', 1800),
  seasonalHero: u('photo-1580587771525-78b9dba3b914', 1800),
  spring: u('photo-1465146344425-f00d5f5c8f07', 1200),
  summer: u('photo-1500382017468-9049fed747ef', 1200),
  fall: u('photo-1477414348463-c0eb7f1359b6', 1200),
  winter: u('photo-1418985991508-e47386d96a71', 1200),
};
